var _path, _rect, _rect2, _rect3, _rect4, _g, _rect5, _rect6, _rect7, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBuilding4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 337,
    viewBox: "0 0 118 337",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H118V337H0V0Z",
    fill: "#171415"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 66,
    width: 58,
    height: 27,
    fill: "#FAFF00"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 242,
    width: 58,
    height: 27,
    fill: "#FAFF00"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 198,
    width: 58,
    height: 27,
    fill: "#FAFF00"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 98,
    y: 54,
    width: 20,
    height: 237,
    fill: "#FAFF00"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_177)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 39,
    transform: "translate(30 298)",
    fill: "#3607F2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 310,
    width: 18,
    height: 28,
    fill: "#FAFF00"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    y: 54,
    width: 20,
    height: 237,
    fill: "#FAFF00"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 110,
    width: 58,
    height: 27,
    fill: "#FAFF00"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 154,
    width: 58,
    height: 27,
    fill: "#FAFF00"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_177"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 39,
    fill: "white",
    transform: "translate(30 298)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding4);
export default __webpack_public_path__ + "static/media/Building4.b73897681e66106df4ecac50b45a0a4e.svg";
export { ForwardRef as ReactComponent };